import { render, staticRenderFns } from "./SujetList.vue?vue&type=template&id=12d317ff"
import script from "./SujetList.vue?vue&type=script&lang=ts"
export * from "./SujetList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports